import { useState, useEffect } from 'react'
import Topbar from '../layouts/Topbar'
import PageHeader from '../components/PageHeader'
import CommonTable from '../components/Common_table'
import SubHeader from '../components/SubHeader'
import { useGlobalContext } from '../../context/Context'
import instance from '../../Utils/api';
import CircularProgress from '@mui/material/CircularProgress';
import Addcatalogue from '../components/Add_catalogue';
import Viewcatalogue from '../components/View_catalogue';
import Cataloguestatus from '../components/Catalogue_Status'

const AdminCategory = () => {
  const columns = [
    { label: "S.No", field: "sno", },
    { label: "Category", field: "category", },
    { label: "Category Image", field: "Bannerimage", },
    { label: "Status", field: "status", },
    { label: "Created Date", field: "createddDate", },
    { label: "Last Updated Date", field: "UpdatedDate", },
    { label: "Actions", field: "action", }
  ];
  const title = { name: "Category", subheading: "Add to the catalogue and view products", search: "", button: "Add category" }
  const { loading, setLoading } = useGlobalContext();
  const { openviewDialog, setopenviewDialog } = useGlobalContext();
  const { openDialog, setOpenDialog } = useGlobalContext();
  const { statusDialog, setstatusDialog } = useGlobalContext();
  const [edit, setEdit] = useState(false);
  const [category, setCategory] = useState([]);
  const [getcategory, setgetCategory] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState(null);

  //fetch category
  const fetchCategory = async () => {
    try {
      const response = await instance.get('/Catalogue/getCategorys')
      const formatteddata = response?.data?.data?.map((cate, index) => ({
        sno: index + 1,
        category: cate?.category,
        Bannerimage: cate?.picture,
        status: cate?.status,
        createddDate: new Date(cate?.createdAt).toLocaleDateString("en-IN", {
          day: "2-digit",
          month: "2-digit",
          year: "numeric",
        }),
        UpdatedDate: new Date(cate?.updatedAt).toLocaleDateString("en-IN", {
          day: "2-digit",
          month: "2-digit",
          year: "numeric",
        }),
        categoryId: cate?._id,
      }))

      setCategory(formatteddata);
    }
    catch (error) {
      console.log("error to fetch category:", error.message)
    } finally {
      setLoading(false);
    }

  }

  useEffect(() => {
    fetchCategory()
    setgetCategory(false)
    setLoading(true);
  }, [getcategory])

  // Handle Row Click for Edit
  const handleEditClick = (cate) => {
    setSelectedCategory(cate); // Set selected category data
    setEdit(true); // Set to edit mode
    setOpenDialog(true);
  };

  // Handle Row Click for view
  const handleViewClick = (cate) => {
    setSelectedCategory(cate); 
    setopenviewDialog(true)
  }
  // Handle Row Click for status change
  const handleStatusClick = (cate) => {
    setSelectedCategory(cate);
    setstatusDialog(true); 
  };

  return (
    <>
      <Topbar />
      <section className='admin-catalogue'>
        <PageHeader
          title={title}
          search={'category'}
          files={false}
          openDialog={openDialog}
          setOpenDialog={setOpenDialog}
        />
        <SubHeader
          menu={false}
          filter={false}
        />
        {loading ?
          <div className='loader-section'>
            <CircularProgress />
          </div>
          :
          <CommonTable
            edit={edit}
            setEdit={setEdit}
            columns={columns}
            rows={category}
            banner={true}
            menu={true}
            showPagination={false}
            openDialog={openDialog}
            setOpenDialog={setOpenDialog}
            openviewDialog={openviewDialog}
            setopenviewDialog={setopenviewDialog}
            handleEditClick={handleEditClick}
            handleViewClick={handleViewClick}
            handleStatusClick={handleStatusClick}
          />
        }
        <Viewcatalogue
          openviewDialog={openviewDialog}
          setopenviewDialog={setopenviewDialog}
          selectedCategory={selectedCategory}
          setgetCategory={setgetCategory}
          mode="category"
        />
        <Addcatalogue
          edit={edit}
          setEdit={setEdit}
          openDialog={openDialog}
          setOpenDialog={setOpenDialog}
          setgetCategory={setgetCategory}
          selectedCategory={selectedCategory}
          mode="category"
        />
        <Cataloguestatus
          statusDialog={statusDialog}
          setstatusDialog={setstatusDialog}
          selectedCategory={selectedCategory}
          setgetCategory={setgetCategory}
          mode="category"
        />
      </section>
    </>
  )
}

export default AdminCategory;
